<template>
  <label>
    {{ title }}
  </label>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },

    computed: {
      title: function () {
        return this.$t(`core.payment.payment_type.${this.item.type}`, {
          number: this.item?.data?.number || '',
          package_name: this.item?.data?.service_package_name || ''
        });
      }
    }
  };
</script>